export interface AnimationProps {
  variant?: string
  [prop: string]: any
}
export const ANIMATION_VARIANTS = {
  loading: 'loading',
}
